import React from 'react';
import type { AboutTelemetryProps } from '../about.types';
import './AboutTelemetry.styles.css';

// * [COMPONENT] Dynamic Fluid Telemetry Panel for the About section
// ? Directly presents verified telemetry, capabilities, and metrics for the focused skill
export const AboutTelemetry: React.FC<AboutTelemetryProps> = ({
  selectedSkill,
  className = '',
}) => {
  if (!selectedSkill) {
    return (
      <div className={`about-telemetry-container ${className}`}>
        <div className="telemetry-skill-view">
          <span className="telemetry-pretag">
            <span className="telemetry-pretag-dot" />
            // System Telemetry
          </span>
          <h3 className="telemetry-title">Engineering Overview</h3>
          <p className="telemetry-tagline">
            Specializing in high-performance web systems and edge architecture.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className={`about-telemetry-container ${className}`}>
      <div className="telemetry-skill-view">
        {/* * Category Identifier */}
        <div className="telemetry-top-bar">
          <span className="telemetry-pretag">
            <span className="telemetry-pretag-dot" />
            // {selectedSkill.category}
          </span>
        </div>

        {/* * Skill Title & Architecture Role */}
        <div className="telemetry-heading-block">
          <h3 className="telemetry-title">{selectedSkill.title}</h3>
          <p className="telemetry-tagline">{selectedSkill.tagline}</p>
        </div>

        {/* * Proficiency & Experience Gauges */}
        <div className="telemetry-meter-wrapper">
          <div className="telemetry-meter-header">
            <span className="telemetry-meter-metric">
              Proficiency & Velocity: <strong>{selectedSkill.proficiency}%</strong>
            </span>
            <span className="telemetry-meter-exp">
              Exp: <strong>{selectedSkill.experienceYears}</strong>
            </span>
          </div>
          <div className="telemetry-meter-track">
            <div
              className="telemetry-meter-bar"
              style={{ width: `${selectedSkill.proficiency}%` }}
            />
          </div>
        </div>

        {/* * Learned Capabilities & Practical Scope */}
        <div className="telemetry-capabilities-card">
          <span className="telemetry-capabilities-heading">
            Capabilities & Execution Scope
          </span>
          <ul className="telemetry-capabilities-list">
            {selectedSkill.learnedCapabilities.map((cap, index) => (
              <li key={index} className="telemetry-capability-item">
                <span className="telemetry-capability-bullet">⚡</span>
                <span className="telemetry-capability-text">{cap}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* * Verified Highlights & Production Proof */}
        <div className="telemetry-highlights">
          {selectedSkill.highlights}
        </div>
      </div>
    </div>
  );
};

export default AboutTelemetry;
